import axios from 'axios';
import { v4 as randomId } from 'uuid';

import { BASE_URL_SERVER } from '../helpers/constants';

const baseURL = BASE_URL_SERVER;

export async function getUserPhotos(userId) {
  const res = await axios.get(baseURL + '/photo', { params: { userId } });
  return res.data;
}
export async function getUserVideos(userId) {
  const res = await axios.get(baseURL + '/video', { params: { userId } });
  return res.data;
}
export async function uploadUserPhoto(files, type, user) {
  if (files.length === 0) return [];
  const fileList = await uploadFiles({ files, type, user });

  const urlList = fileList.map(el => el.url);
  const formData = {
    type,
    description: `${user.name} from ${user.country} `,
    urlList,
    userId: user._id,
  };
  const res = await axios.post(baseURL + '/photo', formData);
  return res.data;
}

export async function uploadUserVideo(files, type, user) {
  if (files.length === 0) return [];
  const fileList = await uploadFiles({ files, type, user });

  const urlList = fileList.map(el => el.url);
  const formData = {
    type,
    description: `${user.name} from ${user.country} `,
    urlList,
    userId: user._id,
  };

  const res = await axios.post(baseURL + '/video', formData);
  console.log(res);

  return res.data;
}

export async function removeUserPhoto(photoId) {
  const res = await axios.delete(baseURL + `/photo/${photoId}`);
  return res.data;
}
export async function removeUserVideo(videoId) {
  const res = await axios.delete(baseURL + `/video/${videoId}`);
  return res.data;
}

const getUploadFileUrl = async ({ filename, fileType, type }) => {
  const res = await axios.get(baseURL + `/file-url`, {
    params: {
      filename,
      fileType,
      type,
    },
  });
  return res.data;
};

const getPublicFileUrl = (fileName, type, region = 'us-east-2') => {
  const bucketName =
    type === 'video' ? 'dating-date-videos' : 'dating-date-photos';
  return `https://${bucketName}.s3.${region}.amazonaws.com/${fileName}`;
};

const uploadFileToS3 = async ({ file, uploadUrl, title }) => {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });
  const url = getPublicFileUrl(title, file.type.split('/')[0]);
  return { title, type: file.type, url };
};

export const uploadFile = async file => {
  const id = randomId();
  const uploadUrl = await getUploadFileUrl({
    filename: id,
    fileType: file.type,
    type: file.type.split('/')[0],
  });
  await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });
  const url = getPublicFileUrl(id, file.type.split('/')[0]);
  return url;
};

export const uploadFiles = async ({ files, type, user }) => {
  files = [...files];
  const urlList = await Promise.all(
    files.map(async file => {
      const filename = `${user.nickname}_${randomId()}`;
      const fileType = file.type;

      // Get the upload URL
      const url = await getUploadFileUrl({
        filename,
        type: file.type.split('/')[0], // Use file type for URL generation
        fileType,
      });

      return {
        file,
        url,
        title: filename,
      };
    }),
  );

  const uploadResults = await Promise.all(
    urlList.map(data =>
      uploadFileToS3({
        file: data.file,
        uploadUrl: data.url,
        title: data.title,
      }),
    ),
  );

  console.log(uploadResults); // Process or log the results
  return uploadResults;
};
